import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

// Pages
import UserLogin from './pages/UserLogin';
import AdminLogin from './pages/AdminLogin';
import AdminRegister from './pages/AdminRegister';
import CoordinatorLogin from './pages/CoordinatorLogin';
import AdminDashboard from './pages/AdminDashboard';
import CoordinatorDashboard from './pages/CoordinatorDashboard';
import ShopifyRedirect from './pages/ShopifyRedirect';
import NotFound from './pages/NotFound';

// Components
import PrivateRoute from './components/PrivateRoute';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<UserLogin />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/register" element={<AdminRegister />} />
          <Route path="/coordinator/login" element={<CoordinatorLogin />} />
          
          {/* Protected Routes */}
          <Route 
            path="/admin/*" 
            element={
              <PrivateRoute role="admin">
                <AdminDashboard />
              </PrivateRoute>
            } 
          />
          
          <Route 
            path="/coordinator/*" 
            element={
              <PrivateRoute role="coordinator">
                <CoordinatorDashboard />
              </PrivateRoute>
            } 
          />
          
          {/* Shopify Redirect */}
          <Route path="/shop" element={<ShopifyRedirect />} />
          
          {/* Not Found */}
          <Route path="/not-found" element={<NotFound />} />
          <Route path="*" element={<Navigate to="/not-found" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
